import _ from "lodash";
import { observer } from "mobx-react";
import React, { useContext } from "react";
import styled from "styled-components";
import { UserInfoContext } from "../../../../WSUtils/UserInfoContext";
import { concatClassnames } from "../../../../WSUtils/util";
import { CVEditListStyles } from "../../CVEditListStyles";
import { CVEditDocument } from "./CVEditDocument";
import { onDownloadDocumentClick } from "./CVEditDownloadDocumentButton";

export interface CVEditDocumentButtonsProps {
  cveDocument: CVEditDocument;
}

export interface CVEditDocumentBaseListProps {
  items: CVEditDocument[];
  OnRenderButtons: (props: CVEditDocumentButtonsProps) => any;
  className: string;
}

export const CVEditDocumentBaseList = observer(
  ({ items, OnRenderButtons, className }: CVEditDocumentBaseListProps) => {
    const userInfo = useContext(UserInfoContext);

    return (
      <CVEditDocumentListStyles
        className={concatClassnames(["cve-list cve-document-list", className])}
      >
        {_.orderBy(items, ["filename", "id"]).map((cveDocument, index) => (
          <div key={cveDocument.id} className="cve-document-list-item">
            <a
              className="cve-document-list-item-name cve-listing-text"
              onClick={(evt) => {
                onDownloadDocumentClick(evt, userInfo, cveDocument);
              }}
            >
              {cveDocument.filename}
            </a>
            <div className="cve-listing-buttons">
              <OnRenderButtons cveDocument={cveDocument} />
            </div>
          </div>
        ))}
      </CVEditDocumentListStyles>
    );
  }
);

export const CVEditDocumentListStyles = styled(CVEditListStyles)`
  &.cve-document-list {
    &.cve-m,
    &.cve-s {
      .cve-document-list-item {
        margin-left: -0.75rem;
        padding-left: 0.75rem;

        max-width: calc(100% + 0.75rem);
      }
    }

    &.cve-document-list.cve-document-list {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .cve-document-list-trashcan {
      flex-shrink: 0;
    }

    .cve-document-listing-position {
      font-weight: bold;
    }

    .cve-document-list-item-name {
      margin: 0.5rem 0;
      text-overflow: ellipsis;
      color: var(--text-color);
      cursor: pointer;
      text-decoration: none;
    }

    .cve-document-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-left: -1rem;
      padding-left: 1rem;

      max-width: calc(100% + 1rem);

      .cve-listing-buttons {
        float: none;
        margin-top: 0;
      }

      &:nth-child(odd) {
        background: var(--surface-50);
      }
    }
  }
`;
